import { useEffect } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import mixpanel from 'mixpanel-browser';

import { LOGIN_SEO_DESCRIPTION, LOGO_NAME, SOURCE_STORAGE_KEY } from '@/constants';
import styles from '@/styles/Onboarding.module.css';
import { EVENT } from '@/analytics';
// import MaintenanceBanner from '../components/MaintenanceBanner';

const Seo = dynamic(() => import('@/head/Seo'));
const SignupSection = dynamic(() => import('@/components/SignupSection'));
const LoginTestimonialSection = dynamic(() => import('@/components/LoginTestimonialSection'));

function SignUp() {
  const router = useRouter();

  useEffect(() => {
    const referrer = router.query.via;
    localStorage?.setItem(
      SOURCE_STORAGE_KEY,
      referrer ? `rewardful-${referrer as string}` : String(router?.query?.utm_source),
    );
  }, [router?.query]);

  useEffect(() => {
    mixpanel.track(EVENT.VIEW_SIGNUP_PAGE);
  }, []);

  return (
    <div className={styles.container}>
      {/* <MaintenanceBanner /> */}
      <Seo title={LOGO_NAME} desc={LOGIN_SEO_DESCRIPTION} />
      <div className={styles.signupContainer}>
        <div className={styles.leftContainer}>
          <SignupSection bypass={false} />
        </div>
        <div className={styles.rightContainer}>
          <LoginTestimonialSection />
        </div>
      </div>
    </div>
  );
}

SignUp.theme = 'light';
export default SignUp;
